import { render, staticRenderFns } from "./C-TreeView.vue?vue&type=template&id=520ea06c&"
import script from "./C-TreeView.vue?vue&type=script&lang=js&"
export * from "./C-TreeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports